import { media } from '@anm/styles/helpers';
import styled from 'styled-components';

const rowOnMobiles = media.tablet`
  display: block;

  & > * {
    max-width: 100%;
    margin-bottom: 16px;
  }
`;

export const Wrapper = styled.div`
  input {
    color: #292a2b;
    margin: 0;

    &::-webkit-input-placeholder {
      color: #919eaa;
    }
  }
`;

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  input {
    margin-bottom: 15px;
  }

  & > * {
    max-width: calc(50% - 21px / 2);
    margin-bottom: 0;
  }
  ${rowOnMobiles};
`;
